<template>
  <div v-if="client != null" class="max-w-xl">
    <div class="font-thin text-3xl">
      Hello there! 😊
    </div>

    <div class="mt-8 text-xl font-thin">
      Thank you for letting me help you with your loan.
    </div>

    <div class="mt-6 text-base leading-normal">
      This tool will help you to accurately collect all your information in one place so that 
      I can select the best product for you and ensure that your loan application has the best chance of success.
    </div>

    <template v-if="privacyAgreed">
      <div class="mt-8 p-3 bg-blue-100 border border-blue-600 text-base leading-normal">
        Thank you for reading and accepting the 
        <a href="https://www.brokerpad.com.au/privacy-policy" target="_blank" class="text-blue-600">Privacy Policy</a>.
        Please watch a short video below which provides you a brief overview of how this online form works
        and when you're ready, you can click on <span class="text-blue-600 font-semibold">Get Started</span>
        to begin your application.
      </div>

      <div class="text-center w-full h-80 mt-8">
        <template v-if="$store.state[$store.state.view + 'Module'].broker.video != null && $store.state[$store.state.view + 'Module'].broker.video.length > 0">
          <iframe 
            class="inputRight" 
            style="width:100%;height:400px;"
            :src="'https://www.youtube.com/embed/' + getYoutubeVideoId($store.state[$store.state.view + 'Module'].broker.video) + '?rel=0'" 
            frameborder="0" 
            allowfullscreen=""></iframe>
        </template>

        <template v-else>
          <iframe 
            style="width:100%;height:400px;"
            src="https://www.youtube.com/embed/o1MFPCF-bcs"
            frameborder="0"
            allowfullscreen></iframe>
        </template>
      </div>

      <div class="mt-4 mb-12">
        <button v-on:click="submit" class="text-white w-full py-4 text-base bg-blue-500 font-semibold">Next : Get started</button>
      </div>
    </template>

    <template v-else>
      <div class="mt-8 font-semibold text-base leading-normal uppercase text-red-500">
        Please read and accept our privacy policy
      </div>

      <div class="mt-3 p-3 bg-red-100 border border-red-dark">
        <div class="text-base leading-normal">
          Your privacy is important to us and to help protect your information there is a range of security features built into this platform.

          Before you begin, please read our 
          <a href="https://www.brokerpad.com.au/privacy-policy" target="_blank" class="text-blue-600">Privacy Policy</a>
        </div>

        <div class="mt-8 text-sm">
          <input type="checkbox" class="mr-2" id="input-privacy" v-model="privacyAgreed" />
          <label for="input-privacy">
            I have read and accept the 
            <a href="https://www.brokerpad.com.au/privacy-policy"
              target="_blank"
              class="text-blue-600">Privacy Policy</a>.
          </label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

  export default {

    data() {
      return {
        client            : null,
        privacyAgreed     : false,
        privacyAgreedError: null
      }
    },

    created() {
      this.logActivity({
        type        : 'welcome-visited',
        clientId    : this.$route.params.clientId,
        currentView : this.$store.state.view
      })

      this.getClient({
        clientId: this.$route.params.clientId,
        force   : true
      }, (client) => {
        this.client = client
      })
    },

  	methods : {
  		submit() {
  			this.$router.push({
					name  : 'application-applicant-profile', 
					params: {
            clientId    : this.$store.state[this.$store.state.view + 'Module'].client.id,
  					applicantId : this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].id
   				}
  			})
  		}
  	}
  }
</script>